import validateEmail from './validateEmail';
import validatePostalCode from './validatePostalCode';

export { default as validateEmail } from './validateEmail';
export { default as validatePostalCode } from './validatePostalCode';

export default {
  validateEmail,
  validatePostalCode
};
